import { handleLayout } from "../layouter";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { ActionIcon, Menu, Tooltip } from "@mantine/core";
import { IconCircuitPushbutton } from "@tabler/icons-react";
import { useReactFlow } from "reactflow";
import ActionsList from "./ActionsList";
import { useState } from "react";
import { defaultNodeConfigs, isMainAction } from "../flowSettings";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { getInheritedCredentials } from "../flowUtils";

const NodeBranchCreator = ({
  source,
  shouldBeEvent,
  sourceX,
  sourceY,
  error,
  isStart,
}) => {
  const lang = useLanguage((s) => s.language);
  const reactFlow = useReactFlow();
  const [opened, setOpened] = useState(false);

  const handleNewBranch = (actionType) => {
    const getId = useFlowStore.getState().getId;
    const nodes = useFlowStore.getState().nodes;
    const setNodes = useFlowStore.getState().setNodes;
    const edges = useFlowStore.getState().edges;
    const setEdges = useFlowStore.getState().setEdges;
    const updateNodeData = useFlowStore.getState().updateNodeData;
    const initialId = useFlowStore.getState().initialId;

    let newNodes = [...nodes];
    let newEdges = [...edges];

    let newNodeId = getId().toString();
    let newEventNodeId = "";

    //#region Choose automatically the same sender as initial action
    let initialActionNode = nodes.find((x) => x.data?.source === initialId)
    const initialType = initialActionNode?.data?.actionType;

    let autoData = { ...defaultNodeConfigs };
    const inheritedCreds = getInheritedCredentials(nodes, source, actionType);

    if (inheritedCreds) {
      autoData.integration_id = inheritedCreds.integration_id;
      autoData.pool_id = inheritedCreds.pool_id;
      autoData.signature_id = inheritedCreds.signature_id;
    }
    //#endregion
    
    // If is start node
    // We create an event node child of Start, parent of initial action
    if (isStart && initialType !== "event") {
      let newEventNodeIdStart = getId().toString();

      newEdges = newEdges.filter((x) => x.source !== source);

      let newEventNodeStart = {
        id: newEventNodeIdStart,
        type: "action",
        data: {
          actionType: "event",
          source,
          error,
          when_minutes: 1,
          event_type: "all_contacts",
        },
        position: { x: sourceX, y: sourceY },
      };
      newNodes.push(newEventNodeStart);

      let newEventEdgeStart = {
        id: `e-${source}-${newEventNodeIdStart}`,
        source: source,
        target: newEventNodeIdStart,
        data: { fromEvent: false, error },
      };
      newEdges.push(newEventEdgeStart);

      // We create an event node parent of initial action
      let newEdgeFromEventStart = {
        id: `e-${newEventNodeIdStart}-${initialActionNode?.id}`,
        source: newEventNodeIdStart,
        target: initialActionNode?.id,
        data: { fromEvent: true, error: false },
      };
      newEdges.push(newEdgeFromEventStart);

      updateNodeData(initialActionNode?.id, { source: newEventNodeIdStart });
    }

    // Event node
    if (shouldBeEvent) {
      newEventNodeId = getId().toString();
      const newEventNode = {
        id: newEventNodeId,
        type: "action",
        data: {
          actionType: "event",
          source,
          error,
          event_type: source === initialId ? "all_contacts" : undefined,
          when_minutes:
            source === initialId ? 1 : defaultNodeConfigs.when_minutes,
        },
        position: { x: sourceX, y: sourceY },
      };
      newNodes.push(newEventNode);

      let newEventEdge = {
        id: `e-${source}-${newEventNodeId}`,
        source: source,
        target: newEventNodeId,
        data: { fromEvent: false, error },
      };
      newEdges.push(newEventEdge);
    }

    const newNode = {
      id: newNodeId,
      type: "action",
      data: {
        actionType: actionType,
        source: shouldBeEvent ? newEventNodeId : source,
        error,
        ...autoData,
      },
      position: { x: sourceX, y: sourceY },
    };
    newNodes.push(newNode);

    // Event to new Node
    let newEdge = {
      id: `e-${shouldBeEvent ? newEventNodeId : source}-${newNodeId}`,
      source: shouldBeEvent ? newEventNodeId : source,
      target: newNodeId,
      data: { fromEvent: true, error },
    };
    newEdges.push(newEdge);

    setNodes(newNodes);
    setEdges(newEdges);
    setOpened(false);

    setTimeout(() => {
      handleLayout();
      setTimeout(() => {
        let nodes = useFlowStore.getState().nodes;
        let n = nodes.find((x) => x.id === newNodeId);
        let e_n = nodes.find((x) => x.id === newEventNodeId);
        const setSelectedNode = useFlowStore.getState().setSelectedNode;
        if (isMainAction(n)) {
          setSelectedNode(n);
          return setTimeout(() => {
            reactFlow?.fitView({
              nodes: e_n ? [n, e_n, { id: source }] : [n, { id: source }],
              duration: 300,
            });
          }, 250);
        }
        reactFlow?.fitView({
          nodes: e_n ? [n, e_n, { id: source }] : [n, { id: source }],
          duration: 300,
        });
      }, 100);
    }, 50);
  };

  return (
    <>
      <Menu
        trigger="click-hover"
        openDelay={200}
        closeDelay={200}
        position={"right"}
        onChange={setOpened}
        shadow="md"
        width={235}
        zIndex={200}
      >
        <Menu.Target>
          <Tooltip label={lang.campaign.nodes.add_branch}>
            <ActionIcon
              size={"sm"}
              style={{ boxShadow: "#00000021 0 1px 3px" }}
              onClick={() => setOpened(true)}
              pos={"absolute"}
              bottom={isStart ? 0 : -28}
              right={0}
              radius={"sm"}
              variant="light"
            >
              <IconCircuitPushbutton size={18} />
            </ActionIcon>
          </Tooltip>
        </Menu.Target>
        <Menu.Dropdown>
          <ActionsList isBranch handleActionClick={handleNewBranch} />
        </Menu.Dropdown>
      </Menu>
    </>
  );
};

export default NodeBranchCreator;
